export const REGISTER_FORM = "forms/REGISTER_FORM";
export const SET_IS_EDITING_FORM = "forms/SET_IS_EDITING_FORM";
export const SET_SHOW_WARNING_MESSAGE = "forms/SET_SHOW_WARNING_MESSAGE";
export const RESET_FORM = "forms/RESET_FORM";
